import { msg } from '@lit/localize';
import type { LoyaltySystemConfig } from '../types';

export const loyaltySystemConfig: LoyaltySystemConfig = {
  pointsName: msg('Mustaches'),
  freeSpinsName: msg('Free Spins'),
  cashbackTerms: msg(
    'Collect Januszcasino Mustaches as you play. Use your accumulated points in loyalty shop to claim exciting rewards like cashbacks, free spins, and other exclusive prizes. Real money bets only. T&C apply.'
  ),
  shopName: msg('JanuszShop')
};
